import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import SVGInline from 'react-svg-inline';

import PlayScreenSpeedSelector from './play-screen-speed-selector';
import ReactionsTimeline from './play-screen-timeline';
import { EmbedContext } from '../../embed-video';
import { useIosSafariRotatedMedia } from '../../../hooks/useIosSafariRotatedMedia';
import { secondsToHumanReadableString } from '../../../../../shared/utilities/time';

import LoadingSpinner from 'components/ui-components/circular-loading-spinner';

import './styles.less';

const BIG_PLAY_BUTTON_SVG = `
<svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M40.3331 73.6667C58.7426 73.6667 73.6664 58.7428 73.6664 40.3333C73.6664 21.9238 58.7426 7 40.3331 7C21.9236 7 6.99976 21.9238 6.99976 40.3333C6.99976 58.7428 21.9236 73.6667 40.3331 73.6667Z" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
  <path opacity="0.6" d="M35 29L51 39.6667L35 50.3333V29Z" fill="#222222" stroke="#222222" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

const PlayScreen = props => {
  const {
    EditVideoButtons,
    ViewerVideoButtons,
    fullScreen,
    isLoading,
    onPlay,
    duration,
    theaterMode,
    isMainVideoOnSharePage,
  } = props;

  const [areVideoButtonsShown, setAreVideoButtonsShown] = useState(false);

  useEffect(() => {
    // short wait before rendering the edit buttons to avoid janky animation
    const timeout = setTimeout(() => {
      setAreVideoButtonsShown(true);
    }, 500);

    return () => {
      // in case the timeout has not executed yet, cancel it
      clearTimeout(timeout);
    };
  }, []);

  const {
    isIosRotatedMedia,
    sourceUrlIsTranscoded,
  } = useIosSafariRotatedMedia();

  if (isIosRotatedMedia && !sourceUrlIsTranscoded) {
    return null;
  }

  const drawPreplayDuration = isMainVideoOnSharePage;

  return (
    <EmbedContext.Consumer>
      {({ hideSpeedSelector }) => (
        <div
          className={classNames(
            'video-player-play-screen',
            isLoading && 'is-loading',
            (theaterMode || fullScreen) && 'large-format'
          )}
          onClick={() => onPlay?.()}
        >
          <div className="button-container">
            <div className="big-play-button">
              {!isLoading && <SVGInline svg={String(BIG_PLAY_BUTTON_SVG)} />}
              {isLoading && (
                <LoadingSpinner color="var(--brandThemedBigPlayButtonIconColor, black)" />
              )}
            </div>
            <div className="relative-el">
              {!hideSpeedSelector && <PlayScreenSpeedSelector />}
              {drawPreplayDuration && duration > 0 && (
                <p className="play-screen-duration">
                  {secondsToHumanReadableString(duration)}
                </p>
              )}
            </div>
          </div>
          <ReactionsTimeline suppressActiveBubble={true} />
          {EditVideoButtons && areVideoButtonsShown && (
            <div className="edit-video-buttons absolute right:0 text:right">
              <EditVideoButtons startCollapsed />
            </div>
          )}
          {ViewerVideoButtons && areVideoButtonsShown && (
            <div className={'viewer-video-buttons absolute right:0 text:right'}>
              <ViewerVideoButtons startCollapsed />
            </div>
          )}
        </div>
      )}
    </EmbedContext.Consumer>
  );
};

export default PlayScreen;
